import { Link, useLocation } from 'react-router-dom';

export const LEGAL_LINKS = [
  ['privacy', 'Privacy Policy'],
  ['terms', 'Terms of Service'],
  ['refund', 'Refund Policy'],
  ['contact', 'Contact Us'],
];

export function LegalLinks({ prefix, compact = false }) {
  const location = useLocation();
  const returnTo = location.pathname === '/' ? `/${location.search}` : location.state?.returnTo || '/';
  return (
    <nav aria-label="Legal and support" data-testid={`${prefix}-legal-links`}
      className={`flex flex-wrap justify-center gap-x-3 gap-y-2 ${compact ? 'text-[9px]' : 'text-[11px]'}`}>
      {LEGAL_LINKS.map(([path, label]) => (
        <Link key={path} to={`/${path}`} state={{ returnTo }} data-testid={`${prefix}-${path}-link`}
          className="text-[#9B3854] font-semibold underline underline-offset-2 hover:text-[#F4436C] transition-colors">
          {label}
        </Link>
      ))}
    </nav>
  );
}